import { AxiosResponse } from "axios";
import {api, apiGateway} from "../config";
import {IColumnData, IFilterOptionsWrapper, ITableSettingsLegacy} from "../../constants/Table/interfaces";

class tableService {

    async setTableSettings(sellerId: number, data: ITableSettingsLegacy, columnData: IColumnData[]): Promise<AxiosResponse> {
        return api.post(`/api/${sellerId}/save-table-settings`, JSON.stringify({ settings: data, columnData: columnData }));
    }

    // async getTableSettings(sellerId: number, tableId: string, isCommon: boolean) {
    //     return api.post(`/api/internal/v1/table-settings/get-common`, JSON.stringify({ data: sellerId, tableId, isCommon }));
    // }

    getTableSettings(sellerId: number, tableId: string, isCommon: boolean) {
        return api(`${process.env.REACT_APP_LEGACY_APP_URL}/api/internal/v1/table-settings/get-common`, {
            method: "POST",
            headers: {
                Accept:         "application/json",
                "Content-Type": "application/json",
            },
            data: {
                sellerId: sellerId,
                tableId: tableId,
                isCommon: isCommon
            }
        })
    }

    // async getTableSettings(sellerId: number): Promise<AxiosResponse> {
    //     return api.get(`/api/${sellerId}/get-table-settings`,)
    // }

    async createTableFilter(sellerId: number, data: IFilterOptionsWrapper): Promise<AxiosResponse> {
        return api.post(`/api/${sellerId}/create-table-filter`, JSON.stringify(data))
    }

    async getSavedTableFilters(sellerId: number): Promise<AxiosResponse> {
        return api.get(`/api/${sellerId}/get-saved-table-filters`)
    }

    async changeSavedTableFilter(sellerId: number, data: IFilterOptionsWrapper): Promise<AxiosResponse> {
        return api.patch(`/api/${sellerId}/change-saved-table-filter`, JSON.stringify(data))
    }

    async deleteSavedTableFilter(sellerId: number, data: IFilterOptionsWrapper): Promise<AxiosResponse> {
        return api.post(`/api/${sellerId}/delete-saved-table-filter`, JSON.stringify(data));
    }

}

export default new tableService();